
// This file maintains the same API as the original mockData.ts
// but imports from modular files

import { PropertyType } from './types/propertyTypes';
import mockProperties from './data/mockProperties';
import { propertyTypes } from './data/propertyTypes';
import { propertyImages } from './data/propertyImages';
import { categories } from './data/categories';

// Re-export everything to maintain the same interface
export type { PropertyType };
export { mockProperties, propertyTypes, propertyImages, categories };

// Define derived data based on the imported data
export const featuredProperties = mockProperties.filter(p => p.isFeatured);

export const searchResultsFeaturedProperties = [
  mockProperties.find(p => p.id === 4),
  mockProperties.find(p => p.id === 8)
].filter(Boolean) as PropertyType[];
